import { quickAddActionCreators } from '@app/components/QuickAddModal/modules/quickAdd'
import { FeedItemToken } from '@app/models/FeedItemToken'
import { IQuickContact } from '@app/models/QuickContact'
import { bindFunctions } from '@app/utils/class'
import { DraftJsMentionPlugin } from 'gateway-draft-js-mention-plugin'
import * as React from 'react'

interface INoSuggestionsProps {
  editorId: string
  onMentionSelect: (mention: any) => any
  searchValue?: string
  theme: DraftJsMentionPlugin.ITheme
}

type NoSuggestionsProps = INoSuggestionsProps & typeof quickAddActionCreators

export default class NoSuggestions extends React.PureComponent<NoSuggestionsProps> {
  constructor(props: NoSuggestionsProps) {
    super(props)
    bindFunctions(this)
  }

  public render() {
    if (!this.props.searchValue) {
      return null
    }

    const {
      editorId,
      onMentionSelect,
      searchValue,
      showQuickAdd,
      theme,
      ...parentProps
    } = this.props

    return (
      <div {...parentProps}>
        <div
          className={theme.mentionSuggestionsEntry}
          onMouseDown={this._onMouseDown}
          onMouseUp={this._onMouseUpConnection}
        >
          Create a new connection for &quot;{searchValue}&quot;
        </div>
      </div>
    )
  }

  private _onMouseDown(event: React.MouseEvent<HTMLDivElement>) {
    event.preventDefault()
  }

  private _onMouseUpConnection(event: React.MouseEvent<HTMLDivElement>) {
    event.preventDefault()
    if (this.props.searchValue) {
      this._showQuickAdd(this.props.searchValue)
    }
  }

  private _onSaveQuickAdd(contact: IQuickContact) {
    const mention = new FeedItemToken({
      id: contact.contactId,
      name: contact.isCompany
        ? contact.lastName
        : `${contact.firstName} ${contact.lastName}`,
      type: 'C',
    })
    this.props.onMentionSelect(mention)
  }

  private _showQuickAdd(name: string) {
    this.props.showQuickAdd(this.props.editorId, name, this._onSaveQuickAdd)
  }
}
